var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55469 18.2246C9.55469 18.2246 9.55469 18.2246 9.55469 18.2247C9.55469 19.6126 10.6798 20.7378 12.0678 20.7378C13.4558 20.7378 14.5809 19.6126 14.5809 18.2247C14.5809 18.2246 14.5809 18.2246 14.5809 18.2246H9.55469Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92837 14.8687L6.05859 16.4861H18.0745L17.2048 14.8687V9.42824C17.2048 6.59049 14.9043 4.29004 12.0666 4.29004C9.22882 4.29004 6.92837 6.59049 6.92837 9.42824V14.8687Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.da491ddb748b1fd68712bdc19f29264c.svg";
export { ForwardRef as ReactComponent };